export const routeSlugs = {
  mk: {
    prefixes: {
      election: "izbori",
    },
    pages: {
      introduction: "voved",
      guide: "vodic",
      question: "prasanje",
      review: "pregled",
      result: "rezultat",
      comparison: "sporedba",
    },
  },
} as const;
